import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 * Drop this inside <BrowserRouter> (in App.jsx) once.
 * Every time the route changes it instantly scrolls window to 0,0.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null; // renders nothing
};

export default ScrollToTop;